// Copyright 2021 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { SettingsModal } from "modules/modals/SettingsModal";
import { WaterfallModule } from "modules/workflows/Streamer/Waterfall/WaterfallModule";

@autoinject
export class StreamerWaterfallSettingsModal extends SettingsModal<WaterfallModule> {}
